var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "requiring-user",
    [
      _c("header", [
        _c("h1", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("edit.title")))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "email-title" }, [
          _vm._v(_vm._s(_vm.user.email))
        ])
      ]),
      _vm._v(" "),
      _c(
        "form-container",
        { attrs: { size: "medium" } },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 3,
                "label-size": "sm",
                "label-class": "text-sm-left",
                label: _vm.$t("edit.firstName"),
                "label-for": "fn"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "fn",
                  name: "fn",
                  type: "text",
                  disabled: _vm.isLoading,
                  "data-vv-as": _vm.$t("edit.firstName")
                },
                model: {
                  value: _vm.user.firstName,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "firstName", $$v)
                  },
                  expression: "user.firstName"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("fn"),
                      expression: "errors.has('fn')"
                    }
                  ],
                  staticClass: "form__error"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.errors.first("fn")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 3,
                "label-size": "sm",
                "label-class": "text-sm-left",
                label: _vm.$t("edit.lastName"),
                "label-for": "ln"
              }
            },
            [
              _c("b-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "ln",
                  name: "ln",
                  type: "text",
                  disabled: _vm.isLoading,
                  "data-vv-as": _vm.$t("edit.lastName")
                },
                model: {
                  value: _vm.user.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "lastName", $$v)
                  },
                  expression: "user.lastName"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ln"),
                      expression: "errors.has('ln')"
                    }
                  ],
                  staticClass: "form__error"
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.errors.first("ln")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                horizontal: "",
                "label-cols": 3,
                "label-size": "sm",
                "label-class": "text-sm-left",
                label: _vm.$t("edit.language"),
                "label-for": "lang"
              }
            },
            [
              _c("b-form-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  id: "lang",
                  name: "lang",
                  options: _vm.languages,
                  disabled: _vm.isLoading,
                  "data-vv-as": _vm.$t("edit.language")
                },
                model: {
                  value: _vm.user.language,
                  callback: function($$v) {
                    _vm.$set(_vm.user, "language", $$v)
                  },
                  expression: "user.language"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("lang"),
                      expression: "errors.has('lang')"
                    }
                  ],
                  staticClass: "form__error"
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errors.first("lang")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isLoading
            ? _c(
                "b-button",
                {
                  attrs: {
                    disabled: !_vm.isValid || _vm.isLoading,
                    variant: "primary"
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("edit.performSave")) + "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading ? _c("loading-indicator") : _vm._e(),
          _vm._v(" "),
          _vm.infoMsg
            ? _c("b-alert", { attrs: { variant: "info", show: 3 } }, [
                _vm._v(_vm._s(_vm.infoMsg))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.errorMsg
            ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                _vm._v(_vm._s(_vm.errorMsg))
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b6ceb74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6ceb74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditScreen.vue
// module id = null
// module chunks = 